import type { XingletInterface } from '../../jobs-xinglet';
import { JobsXingletWrapper } from '../../jobs-xinglet';

export type AIEarnMoreDialogXinglet = XingletInterface;

export type AIEarnMoreDialogProps = {
  /**
   * The dialog will be displayed as soon as the `value` is provided
   * The value should be a number between 30_000 and 200_000
   */
  value: number | null;
  onClose: () => void;
  onForceQuery: () => void;
};
export const AIEarnMoreDialog = JobsXingletWrapper<AIEarnMoreDialogProps>(
  '@xing-com/crate-jobs-domain-search-ai-earn-more-dialog'
);
